import React from 'react';

function Navbar() {
  return <div>
  <div className='flex bg-black text-white justify-center px-8 py-4 font-kry font-bold text-6xl hover:text-[#1BEEFF] cursor-pointer'>
    {/* <div>Contact Me</div> */}
    <div>R S .</div>
    {/* <div className='flex gap-2 items-center'>Menu
    <img src="/images/Icon.svg" alt="" />
    </div> */}
  </div>
  </div>;
}

export default Navbar;
